import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try {
      const c = JSON.parse(localStorage.getItem("aubone-cart") || "[]");
      return Array.isArray(c) ? c : [];
    } catch (e) { return []; }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastShow, setToastShow] = useState(false);
  const toastTimer = useRef(null);

  useEffect(() => {
    try { localStorage.setItem("aubone-cart", JSON.stringify(cart)); } catch (e) { /* noop */ }
  }, [cart]);

  const toast = useCallback((msg) => {
    setToastMsg(msg);
    setToastShow(true);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToastShow(false), 2200);
  }, []);

  const addToCart = useCallback((item) => {
    setCart(prev => {
      const ex = prev.find(c => c.key === item.key);
      if (ex) return prev.map(c => c.key === item.key ? { ...c, qty: c.qty + (item.qty || 1) } : c);
      return [...prev, { ...item, qty: item.qty || 1 }];
    });
    toast("Added to cart");
  }, [toast]);

  const changeQty = useCallback((index, delta) => {
    setCart(prev => {
      const next = prev.map((c, i) => i === index ? { ...c, qty: c.qty + delta } : c);
      return next.filter(c => c.qty > 0);
    });
  }, []);

  const clearCart = useCallback(() => setCart([]), []);

  const cartTotal = cart.reduce((s, c) => s + c.price * c.qty, 0);
  const cartCount = cart.reduce((s, c) => s + c.qty, 0);
  const shipping = cart.some(c => c.qty >= 6 || c.name.includes("set")) ? 0 : 25;

  const openCart = useCallback(() => setDrawerOpen(true), []);
  const closeCart = useCallback(() => setDrawerOpen(false), []);

  return (
    <CartContext.Provider value={{ cart, addToCart, changeQty, clearCart, cartTotal, cartCount, shipping, drawerOpen, openCart, closeCart, toast, toastMsg, toastShow }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
